export default "__VITE_ASSET__JbQQ7MyN__"